// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aCkPqQczGG7ilRHEczSY {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
}

.P5Ed7m1n9u2VBgBjHFYg {
  max-height: 100%;
  height: 95%;
  overflow-y: auto;
  overflow-x: hidden;
  background: rgb(var(--primary-bg));
}

.axmkCCTF4nMOTTzlF2WS {
  width: 100%;
  margin-bottom: 24px;
}

.nQAkP9Z5RAQ4qK0VRj0Z {
  color: rgb(var(--accent-brand));
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  background: transparent;
  cursor: pointer;
  border: none;
  z-index: 305;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.3s ease 0s;
}

.nQAkP9Z5RAQ4qK0VRj0Z > svg {
  cursor: pointer;
  > path {
    stroke: rgb(var(--accent-brand));
  }
}

.nQAkP9Z5RAQ4qK0VRj0Z:first-child {
  justify-content: flex-start;
}

.nQAkP9Z5RAQ4qK0VRj0Z:hover {
  background: transparent;
}

.nQAkP9Z5RAQ4qK0VRj0Z:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .modalTopButton:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.xMvahB16VeOw9BIquyYd {
  font-size: 32px;
  text-align: center;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  margin: 0 auto;
}

.PkVsqln9R7XrTv2PlbPG {
  display: flex;
  justify-content: center;
  width: max-content;
  margin: 0 auto;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-bottom: 24px;
  padding: 12px;
  border-radius: 20px;
  background: rgba(var(--secondary-bg), 0.40);
  transition: background 0.3s ease 0s;
}

.PkVsqln9R7XrTv2PlbPG:hover {
  background: rgba(var(--secondary-bg), 0.70);
}

.mjzgaeymqahOFoyZvjky {
  color: rgb(var(--placeholder-primary));
  text-transform: uppercase;
  word-break: break-word !important;
  font-size: 14px;
  line-height: 50%;
  font-weight: 590;
}

.BDbRph5QgXo5kv_z6EKD {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
}

.DBzx3OSEN1AcXJnhyNVh {
  font-size: 16px;
  text-align: center;
}

.DBzx3OSEN1AcXJnhyNVh > span {
  font-weight: 760;
}

.uDbVXsbAmrEBMiP_0oxI {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 40%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(0, 122, 255, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}

/*--------------------alert--------------------*/

.SRmmYboUWG0I9gAt2r8j {
  color: #fff;
  background: rgb(var(--accent-brand));
  border: 0;
  border-radius: 10px 0 0 10px;
}

.SRmmYboUWG0I9gAt2r8j > button {
  color: #fff !important;
}
  
/*--------------------/alert--------------------*/`, "",{"version":3,"sources":["webpack://./src/pages/main/send/receive-modal/receive-modal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA,gDAAgD;;AAEhD;EACE,WAAW;EACX,oCAAoC;EACpC,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\n  max-height: 100%;\n  height: 95%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: rgb(var(--primary-bg));\n}\n\n.modalTop {\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.modalTopButton {\n  color: rgb(var(--accent-brand));\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  z-index: 305;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background 0.3s ease 0s;\n}\n\n.modalTopButton > svg {\n  cursor: pointer;\n  > path {\n    stroke: rgb(var(--accent-brand));\n  }\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  background: transparent;\n}\n\n.modalTopButton:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .modalTopButton:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.modalTitle {\n  font-size: 32px;\n  text-align: center;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  margin: 0 auto;\n}\n\n.modalAddress {\n  display: flex;\n  justify-content: center;\n  width: max-content;\n  margin: 0 auto;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin-bottom: 24px;\n  padding: 12px;\n  border-radius: 20px;\n  background: rgba(var(--secondary-bg), 0.40);\n  transition: background 0.3s ease 0s;\n}\n\n.modalAddress:hover {\n  background: rgba(var(--secondary-bg), 0.70);\n}\n\n.modalAddressTitle {\n  color: rgb(var(--placeholder-primary));\n  text-transform: uppercase;\n  word-break: break-word !important;\n  font-size: 14px;\n  line-height: 50%;\n  font-weight: 590;\n}\n\n.modalQr {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px auto;\n}\n\n.modalDescription {\n  font-size: 16px;\n  text-align: center;\n}\n\n.modalDescription > span {\n  font-weight: 760;\n}\n\n.background {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 40%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(0, 122, 255, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}\n\n/*--------------------alert--------------------*/\n\n.alert {\n  color: #fff;\n  background: rgb(var(--accent-brand));\n  border: 0;\n  border-radius: 10px 0 0 10px;\n}\n\n.alert > button {\n  color: #fff !important;\n}\n  \n/*--------------------/alert--------------------*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `aCkPqQczGG7ilRHEczSY`,
	"modal": `P5Ed7m1n9u2VBgBjHFYg`,
	"modalTop": `axmkCCTF4nMOTTzlF2WS`,
	"modalTopButton": `nQAkP9Z5RAQ4qK0VRj0Z`,
	"modalTitle": `xMvahB16VeOw9BIquyYd`,
	"modalAddress": `PkVsqln9R7XrTv2PlbPG`,
	"modalAddressTitle": `mjzgaeymqahOFoyZvjky`,
	"modalQr": `BDbRph5QgXo5kv_z6EKD`,
	"modalDescription": `DBzx3OSEN1AcXJnhyNVh`,
	"background": `uDbVXsbAmrEBMiP_0oxI`,
	"alert": `SRmmYboUWG0I9gAt2r8j`
};
export default ___CSS_LOADER_EXPORT___;
